<template>
    <div class="view view--advanced-search">
        <advanced-search />
    </div>
</template>

<script>
    import advancedSearch from '../components/AdvancedSearch.vue';

    export default {
        components: {
            advancedSearch
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/AdvancedSearch.vue